const Tech =()=>{
    return(
        <div className="slider-1">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    
                    <div className="slider-container">
                        <div className="swiper-container image-slider">
                            <div className="swiper-wrapper">
                                <div className="swiper-slide">
                                        <img className="img-fluid" src="images/customer-logo-1.png" alt="alternative" />
                                </div>
                                <div className="swiper-slide">
                                        <img className="img-fluid" src="images/customer-logo-2.png" alt="alternative" />
                                </div>
                                <div className="swiper-slide">
                                        <img className="img-fluid" src="images/customer-logo-3.png" alt="alternative" />
                                </div>
                                <div className="swiper-slide">
                                        <img className="img-fluid" src="images/customer-logo-4.png" alt="alternative" />
                                </div>
                                <div className="swiper-slide">
                                        <img className="img-fluid" src="images/customer-logo-5.png" alt="alternative" />
                                </div>
                                <div className="swiper-slide">
                                        <img className="img-fluid" src="images/customer-logo-6.png" alt="alternative" />
                                </div>
                            </div>
                        </div>
                    </div> 
                    </div>
                </div>
            </div>
            </div>
    )
}

export default Tech;